import { toast } from '@/components/toast';
import { NotificationTopics, useNotifications } from '@/services/notification/notificationProvider';
import { Subject } from '@d-id/types';
import { useEffect } from 'react';
import { useQueryClient } from 'react-query';
import { GET_TRANSLATION_GROUPS_KEY, GET_TRANSLATIONS_KEY, handlePartialGroupEvent, handleTranslationErrors } from './translationLibrary';

export const useTranslationsGroupNotifications = () => {
    const { subscribe, unsubscribe } = useNotifications();
    const queryClient = useQueryClient();

    useEffect(() => {
        const subscriptionId = subscribe(NotificationTopics.translation, async (event: MessageEvent) => {
            try {
                await Promise.all([
                    queryClient.invalidateQueries(GET_TRANSLATION_GROUPS_KEY),
                    queryClient.invalidateQueries(GET_TRANSLATIONS_KEY),
                ]);
                const parsedMessage = JSON.parse(event.data);
                const subject = parsedMessage.messageAttributes.subject.stringValue;
                if (subject === Subject.TranslationGroupPartialDone) {
                    handlePartialGroupEvent(parsedMessage.body);
                } else if (subject === Subject.TranslationGroupPostDone) {
                    toast.success({ title: 'Video translated to all languages!' });
                } else {
                    handleTranslationErrors(subject, parsedMessage.body);
                }
            } catch {}
        });
        return () => {
            unsubscribe(NotificationTopics.translation, subscriptionId);
        };
    }, []);
};
